import isPlainObject from "lodash-es/isPlainObject";
import { webix } from "extensions/webix";

import { store } from "common/store";

const onFilterChange = function(table, cacheReportFilter) {
    const appliedFilters = Object.entries(table._filter_elements).reduce((memo, [key, value]) => {
        if (table.isColumnVisible(key)) {
            const val = value[2].getValue(value[0]);
            if (val) {
                return {
                    ...memo,
                    [key]: val.split(",")
                };
            }
        }
        return memo;
    }, Object.create(null));
    cacheReportFilter(appliedFilters);
};

const makeHeader = function(key, {
    single, isArray, isObject, cacheReportFilter
}) {
    if (single || isArray || isObject) {
        return key;
    }
    
    return [{
        content: "pazienSelectFilter",
        onChange(master, arg1, arg2) {
            // if (key === "op_incident_assignee") {
            // } else {
            master.filterByAll();
            onFilterChange(master, cacheReportFilter);
            // }
        },
        separator: "|",
        inputConfig: {
            label: key,
            separator: "|"
        },
        suggest: {
            fitMaster: false,
            selectAll: true,
            sortOptions: true,
            width: 300
        }
    }];
};

export const columnsMapper = function({
    single, walk, cacheReportFilter, overrides = [], canonicalName = null
} = {}) {
    return function([key, value], index, all) {
        let sortAs = "string";
        const isArray = Array.isArray(value);
        const isObject = isPlainObject(value);
        
        // we need this for child reports
        // so that right-clicking on the id redirects to the correct report
        // and for actions so that we disable _id clickability.
        // child reports have a three-part canonical name:
        // <suite>__<parent>__<report>
        // actions have a four-part canonical name:
        // <suite>__<parent>__<action>__<action_type>

        const fullCanonicalNameList = canonicalName?.split("__");
        let reportCanonicalName;
        let disableId = false;
        if (fullCanonicalNameList.length === 3) {
            reportCanonicalName = `${fullCanonicalNameList[0]}__${fullCanonicalNameList[fullCanonicalNameList.length - 1]}`;
        } else if (fullCanonicalNameList.length === 4) {
            disableId = true;
        }
    
        if (isArray) {
            sortAs = function(a, b) {
                if (a[key].length > b[key].length) return 1;
                if (a[key].length < b[key].length) return -1;
                return 0;
            };
        } else if (Number.isFinite(value)) {
            // Sort as integer
            sortAs = "int";
        }
    
        return {
            id: key,
            header: makeHeader(key, {
                single, isArray, isObject, cacheReportFilter
            }),
            width: 200,
            minWidth: 200,
            fillspace: index === all.length - 1,
            adjust: key === "_id",
            sort: sortAs,
            template: (obj, common, _value) => {
                if (key === "_id" && !disableId) {
                    return `<a rel="noopener noreferrer" href='/merchant/administrator/reports/${reportCanonicalName || store.getState().reports.options.id}/itemId:${_value}?merchant=gujm' target="_blank">${_value}</a>`;
                }
                // The override is used to set the field as a link
                const fieldOverride = overrides?.find(
                    (override) => override.column_value === key && typeof override.column_ref_path !== "undefined"
                );
                if (typeof fieldOverride !== "undefined") {
                    const href = fieldOverride.column_ref_path.replace(/<_id>/, _value);
                    return `<a href=${href} target="_blank" rel="noopener noreferrer">${_value}</a>`;
                }

                if (Array.isArray(obj[key])) {
                    return `[0 ${obj[key].length} items]`;
                }
            
                if (isPlainObject(obj[key])) {
                    return "[Object]";
                }
                
                if (!Object.prototype.hasOwnProperty.call(obj, key)) {
                    return "-";
                }
                
                if (obj[key] === null) {
                    return "<span class='not-available'>null</span>";
                }
                
                return webix.template.escape(obj[key]);
            },
            css: isArray || isObject || (key === "_id" && !disableId) ? "drillable" : ""
        };
    };
};
